import { useField } from "formik";

import RadioButtons from "components/RadioButtons";

const FormikRadioButtons = ({ name, ...rest }) => {
  const [field, meta, helpers] = useField({ name });

  const handleChange = (value) => {
    helpers.setValue(value);
  };

  return (
    <RadioButtons {...rest} {...field} {...meta} onChange={handleChange} />
  );
};

export default FormikRadioButtons;
